const mergeLocalStorage = (key, obj) => {
    var newObj = JSON.parse(localStorage.getItem(key));
    for (var k in obj){
        newObj[k] = obj[k];
    }
    localStorage.setItem(key, JSON.stringify(newObj));
}

export default mergeLocalStorage;